import "../css/donate.css";

const ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};
ready(() => {
  document.querySelectorAll(".donate-level-toggle").forEach((el) => {
    el.addEventListener(
      "click",
      (event) => {
        el.classList.toggle("donate-level-open");
      },
      true
    );
  });
});
